'use strict';

/*global app*/
/*global services*/
/*global BasicProcess*/
/*global invokeCallback*/

function ReceiptCardProcess(containerId, settings) {
  BasicProcess.call(this, containerId, settings);

  this.init();
}

ReceiptCardProcess.prototype = $.extend({}, BasicProcess.prototype, {
  constructor: 'ReceiptCardProcess',

  registerCallbacks: function registerCallbacks() {
    var _this = this;

    return _this;
  },

  //----------------------------------------------------------------------------

  backForm: function backForm() {
    var _this = this;

    app.confirmCancelHtml(app.t('k2_location.confirm_leave_page_help_with_continue'), function (ret) {
      if (ret === null) {
        return;
      }

      _this.isFormBack = true;

      if (!ret) {
        _this.revertWebDocument = true;

        _this.onBeforeLeavePage();
      }

      _this.redirectToGoTo();
    });

    return _this;
  },

  getLocationByFirstItem: function getLocationByFirstItem(location) {
    var _this = this;

    var $item = _this.$form.find('.process-items .process-item:first');
    return {
      Id: $item.find('[name$="[' + location + 'LocationId]"]').val(),
      Abbr: $item.find('[name$="[' + location + 'Location]"]').val(),
    };
  },

  getToLocationByFirstItem: function getToLocationByFirstItem() {
    var _this = this;

    return _this;
  },

  /*
  //nalezy zatim neresime, jakmile bude potreba toto povolit a patricne upravit funkcionalitu v K2
  //nutne upravit nastaveni funkcionality v receipt_card_process.html.twig - allowedHighAmount: true - nyni je zakazano
  itemNotFound: function itemNotFound(data) {
    var _this = this;

    app.confirmHtml(sprintf(app.t('receipt_card_process.article_not_found'), data.Name), function (res) {
      if (res) {
        var fromLocation = _this.getLocationByFirstItem('From');
        var toLocation = _this.getLocationByFirstItem('To');

        data.FromLocationId = fromLocation.Id;
        data.FromLocation = fromLocation.Abbr;

        data.ToLocationId = toLocation.Id;
        data.ToLocation = toLocation.Abbr;

        console.log(data);

        _this.processNewItem(data);
      }
    });

    return _this;
  },
  */

  onBeforeSubmitPage: function onBeforeSubmitPage(callback) {
    var _this = this;

    if (_this.getItems().length) {
      invokeCallback(callback);
    } else {
      app.confirmHtml(app.t('receipt.confirm_receipt_card'), function (res) {
        if (res) {
          services.get('receipt-service').confirmReceiptCardByWebDocument(_this.getWebDocumentRID(), function () {
            return _this.onAfterSubmitFormFinish();
          });
        }
      });
    }

    return _this;
  },

  onAfterSubmitForm: function onAfterSubmitForm() {
    var _this = this;

    var $preparedItems = _this.getPreparedItems();
    if ($preparedItems.length) {
      return _this.onAfterSubmitFormFinish();
    } else {
      app.confirmHtml(app.t('receipt.confirm_receipt_card'), function (res) {
        if (!res) {
          return _this.onAfterSubmitFormFinish();
        }

        services.get('receipt-service').confirmReceiptCardByWebDocument(_this.getWebDocumentRID(), function () {
          return _this.onAfterSubmitFormFinish();
        });
      });
    }

    return _this;
  },

  //----------------------------------------------------------------------------

  init: function init() {
    var _this = this;

    _this.registerCallbacks();

    return _this;
  }
});
